import { useTranslation } from 'react-i18next'
import { getVkVideoEmbedUrl } from '../../utils/vkVideo'
import './VkVideoEmbed.css'

function VkVideoEmbed({ url, title, showExternalLink = true }) {
  const { t } = useTranslation()
  const embedUrl = getVkVideoEmbedUrl(url)

  if (!embedUrl) {
    return (
      <div className="vk-video-embed vk-video-embed--unavailable">
        <p>{t('videos.embedUnavailable', 'Видео нельзя встроить. Откройте запись на VK.')}</p>
        {url && (
          <a href={url} target="_blank" rel="noopener noreferrer" className="vk-video-embed__external">
            {t('videos.watchOnVk')}
          </a>
        )}
      </div>
    )
  }

  return (
    <div className="vk-video-embed">
      <div className="vk-video-embed__frame">
        <iframe
          src={embedUrl}
          title={title || 'Video'}
          allow="autoplay; encrypted-media; fullscreen; picture-in-picture; screen-wake-lock"
          frameBorder="0"
          allowFullScreen
          loading="lazy"
        />
      </div>
      {showExternalLink && url && (
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="vk-video-embed__external"
        >
          {t('videos.watchOnVk')}
        </a>
      )}
    </div>
  )
}

export default VkVideoEmbed
